import { EmptyGuid } from '@/domain/constants'

import msalApi from "../config/setupMSALAxios"; // your configured Axios instance


export interface IDelegateWorkPatientsRequest {
  recipient: string
  message: string
  sourceId: number
  recordIds: Array<number>
}

export async function fetchWidgetSummarylist() {
  // console.log('***  workList  API . ts ')
  // console.log('               API fetchWidgetSummarylist')
  const result = await msalApi('/api/Campaign/GetWidgetSummary')
  return result.data

}
export async function fetchWidgetSummaryDetail(widgetId: number) {

  // // console.clear()
  // // console.log('***  workList  API . ts ')
  // // console.log('  GET  SUMMARY  DETAIL            API fetchWidgetSummaryDetail   ID')
  // // console.log('              widgetId')
  // // console.log(widgetId)

  const result =   await msalApi('/api/Campaign/GetSummaryWidgetDetail', { params: { widgetId } })
  return result.data

}

export async function fetchAllMyWork() {
  // // // console.log('***  workList  API . ts ')
  // // // console.log(' API fetchAllMyWork')
  // // console.log('************************  /Campaign/GetAllMyWork')
  const result = await msalApi('/api/Campaign/GetAllMyWork')
  return result.data
}

export async function fetchAllMyAlerts() {
  // // console.log('***  workList  API . ts ')
  // // console.log(' API fetchAllMyAlerts')
  // // console.log('************************  /api/Campaign/GetAllMyAlerts')
  const result = await msalApi('/api/Campaign/GetAllMyAlerts')
  return result.data
}


export async function fetchAllMyDelegatedWork() {
  const result = await msalApi('/api/Campaign/GetAllMyDelegatedWork')
  return result.data
}
export async function fetchAllMyOtherWork() {
  const result = await msalApi('/api/Campaign/GetAllMyOtherWork')
  return result.data
}
export async function fetchAllMyAssignedWork() {
  const result = await msalApi('/api/Campaign/GetAllMyAssignedWork')
  return result.data
}
export async function fetchMyWork(filter) {
  const result = await msalApi(`/api/Campaign/GetMyWork?filter=${filter}`)
  return result.data
}

export async function fetchMyWorkDetails(personId: number) {
  // // console.log(' WORKLIST  API  > fetchMyWorkDetails    Campaign/GetMyWorkDetails   >>')
  const result = await msalApi('/api/Campaign/GetMyWorkDetails', { params: { personId } })
  return result.data
}

export async function fetchMyDelegatedWork(filter) {
  const result = await msalApi(`/api/Campaign/GetMyDelegatedWork?filter=${filter}`)
  return result.data
}

export async function fetchMyDelegatedWorkDetails(personId: number) {
  const result = await msalApi('/api/Campaign/GetMyDelegatedWorkDetails', { params: { personId } })
  return result.data
}
// * fetchMyOtherWork
export async function fetchMyOtherWork(filter) {
  const result = await msalApi(`/api/Campaign/GetMyOtherWork?filter=${filter}`)
  return result.data
}
// * fetchMyOtherWorkDetails
export async function fetchMyOtherWorkDetails(userMessageId: string) {
  // // // console.log('     fetchMyOtherWorkDetails')
  // // // console.log('                                     userMessageId: ', userMessageId)
  const result = await msalApi('/api/Campaign/GetMyOtherWorkDetails', { params: { userMessageId } })
  return result.data
}
// * fetchMyAssignedWorkDetails
export async function fetchMyAssignedWorkDetails(userMessageId: string) {
  // // // console.log('     fetchMyAssignedWorkDetails')
  // // // console.log('                                     userMessageId: ', userMessageId)
  const result = await msalApi('/api/Campaign/GetMyAssignedWorkDetails', { params: { userMessageId } })
  return result.data
}

// & MEASURES
export async function fetchMyMeasures() {
   // console.log('        WORKLIST  API      fetchMyMeasures    >> ')
  const result = await msalApi('/api/Campaign/GetAllMyMeasures')
  return result.data
}
export async function fetchMyMeasuresDetails(providerName: string) {
  const result = await msalApi('/api/Campaign/GetAllMyMeasuresDetails', { params: { providerName } })
  return result.data
}
export async function fetchAllMyMeasures(filter) {
  const result = await msalApi(`/api/Campaign/GetAllMyMeasures?filter=${filter}`)
  return result.data
}


export async function takeBackDelegatedPatients(recordIds: Array<number>) {
  const result = await msalApi.post('/api/Campaign/TakeBackDelegatedPatients', { recipient: EmptyGuid, message: null, sourceId: null, recordIds })
  return result.data
}

export async function delegateWorkPatients(delegateRequest: IDelegateWorkPatientsRequest) {
  return msalApi.post('/api/Campaign/DelegateWork', delegateRequest).then((result) => result.data)
}

//^ new postNewAlertMessage
export async function postNewAlertMessage(alertMessage: object) {
  // console.log('   postNewAlertMessage')
  // console.dir(alertMessage)
  const result = await msalApi.post('/api/Campaign/PostAlert', alertMessage)
  return result.data
}


export async function setAlertViewed(id: Number) {
  // console.log('   setAlertViewed')
  // console.log('                   id')
  // console.log(id)
  let objRe = {id: id}
  // console.log(objRe)

  return msalApi.post('/api/Campaign/PostAlertViewed',  objRe  ).then((result) => result.data)
}
